import { Component, OnInit  } from '@angular/core';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ngx-cambiar-password',
  templateUrl: './cambiar-password.component.html',
  providers: [UtilidadesService,PeticionesHttpBackEndService]
})
export class CambiarPasswordComponent implements OnInit {

  Email: String = "";
  Exito: Boolean = false;
  loading: Boolean = false;
  MensajeError: Boolean = false;
  Mensaje: String = "";
  parametrosUrl: any;
  NewPassword : any;

  Password1: any = "";
  Password2: any = "";
  Password3: any = "";
  Token: any;
  Usuario:any;
  constructor(private _route: ActivatedRoute, private utilidades: UtilidadesService, public _http: PeticionesHttpBackEndService,private router:Router){
    _route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
    });
    
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
  }


  ngOnInit() {
    
  }

  CambiarPassword(){
    this._http.getUsuario().subscribe(
      result => {
        this.Usuario = result;
        let resultado: any;
    if (this.Password1 == "" || this.Password2 == ""){
      this.utilidades.notificationWarning("Aviso","Por favor, introduce una contraseña","top-left");
    }else{
      if (this.Password1 != this.Password2){
        this.utilidades.notificationWarning("Aviso","Las contraseñas tienen que ser iguales","top-left");
      }else{
        this.NewPassword = this.Password2;
        this._http.postRequestPublic("cambiaPassword",{Data:{PassActual:this.Password3,NewPassword:this.NewPassword,Entidad:this.Usuario.Entidad._entidad_id}}).subscribe(
          result => {
            resultado = result;
            if (resultado.Code == 200){
              setTimeout(()=>{
                this.router.navigate(['auth/login']);
              }, 4000);
              this.Exito = true;
              this.loading = true;
            }else if(resultado.Code == 1000){
              this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
            }
          }
        )
      }
    }
      }
    )
        
  }
 
}